import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import logoIscert from '../assets/logo-iscert.svg';
import { useAuth } from "../utils/authContext";
import { validatePin } from "../services/userInfoService";
import { getFile, getFileSign, storeFile } from "../utils/indexedDB";
import { signDocument } from "../services/signService";
import '../assets/iscert/css/iscert.css';

export const Pin = () => {

    const { t } = useTranslation();
    const [pin, setPin] = useState('');
    const [attempts, setAttempts] = useState(4);
    const [error, setError] = useState('');
    const [showPin, setShowPin] = useState(false);
    const navigate = useNavigate();
    const { token } = useAuth();
    const signIdentityId = localStorage.getItem('userId');
    const certificateId = localStorage.getItem("certificateId")
    const fileName = localStorage.getItem('fileName');
    const handleInputChange = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9]*$/.test(value)) {
            setPin(value);
            if (error) setError('');
        }
    };

    const handleClear = () => {
        setPin('');
        setError('');
    };

    const toggleShowPin = () => {
        setShowPin(!showPin);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (pin === '') {
            setError('El PIN no puede estar vacío.');
        } else {
            try {
                const validationResponse = await validatePin(token, signIdentityId, certificateId, pin);
                if (validationResponse.result === 'valid') {
                    const pdfFile = await getFileSign(fileName);

                    let requestJson = {};
                    if (sessionStorage.getItem('configs')) {
                        const configs = JSON.parse(atob(sessionStorage.getItem('configs')));
                        if (configs.SIGN_AUTH_REQUIRED) {
                            const appearance = JSON.parse(localStorage.getItem('appearance'));
                            requestJson = {
                                "type": "PADES_BASIC",
                                "keyStore": {
                                    "id": certificateId,
                                    "credentials": {
                                        "secret": pin
                                    }
                                },
                                "appearance": appearance,
                                "text": {
                                    "value": "Esta es la apariencia a usar por MiRecibo"
                                }
                            };
                        } else {
                            requestJson = {
                                "type": "PADES_BASIC",
                                "keyStore": {
                                    "id": certificateId,
                                    "credentials": {
                                        "secret": pin
                                    }
                                },
                                "appearance": {
                                    "image": {
                                        "value": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/aykKHkAAAAASUVORK5CYII="
                                    },
                                    "location": {
                                        "page": "1",
                                        "frame": {
                                            "lowerLeft": {
                                                "x": 0,
                                                "y": 0
                                            },
                                            "upperRight": {
                                                "x": 0.1,
                                                "y": 0.1
                                            }
                                        }
                                    }
                                },
                                "text": {
                                    "value": "Esta es la apariencia a usar por MiRecibo"
                                }
                            };
                        }
                    }
                    // Firmar el documento
                    const signedPdfBlob = await signDocument(token, pdfFile, requestJson);

                    // Reemplazar el archivo PDF firmado en IndexedDB
                    const reader = new FileReader();
                    reader.onload = async () => {
                        const base64File = reader.result.split(',')[1]; // Obtener la parte base64 del resultado
                        console.log(base64File);
                        await storeFile(fileName, base64File);
                        navigate('/signer/sharedDocument', { state: { alertType: 'success', alertMessageKey: 'componentAlerts.success' } });
                    };
                    reader.readAsDataURL(signedPdfBlob);
                } else {
                    setAttempts(validationResponse.remaining_attempts);
                    if (validationResponse.remaining_attempts === 0) {
                        setError('PIN de firma bloqueado. El certificado ha sido deshabilitado.');
                    } else {
                        setError(`PIN de firma incorrecto. Por favor, vuelva a intentarlo. Intentos restantes hasta bloquear su PIN de firma: ${validationResponse.remaining_attempts}`);
                    }
                }
            } catch (error) {
                setError('Error al validar el PIN. Por favor, inténtelo de nuevo.');
                navigate('/signer/signDocument', { state: { alertType: 'error', alertMessageKey: 'componentAlerts.error' } });
            }
        }
    };

    const handleCancel = () => {
        navigate('/signer/signDocument');
    };

    return (
        <section id="cripto">
            <div className="brand-logo">
                <img className="img-fluid" src={logoIscert} alt="Logotipo iSCert" />
            </div>
            <form className="form-signin needs-validation" onSubmit={handleSubmit} noValidate>
                <h2 className="txt-info">{t('pin.title')}</h2>
                <div className="input-area">
                    <input
                        className="form-control"
                        type={showPin ? "text" : "password"}
                        value={pin}
                        onChange={handleInputChange}
                        required
                    />
                    <button type="button" className="btn btn-show-pin" onClick={toggleShowPin}>
                        <i className={`icon-eye${showPin ? '-off' : ''}`}></i>
                    </button>
                </div>
                {error && (
                    <div className="alert-message">
                        <p>{error}</p>
                    </div>
                )}
                <div className="form-group mb-0">
                    <button className="btn btn-login btn-block" type="submit" disabled={pin === ''}>

                        {t('consent.confirm-button')}
                    </button>
                    <a className="btn link-cancel" type="button" onClick={handleCancel}>

                        {t('consent.cancel-button')}
                    </a>
                </div>
            </form>
        </section>
    );
};
